let revealMoreButton = document.querySelectorAll('.reveal-more-btn');
let hideMoreButton = document.querySelectorAll('.hide-more-btn');


if(revealMoreButton && hideMoreButton) {
    //console.log('yes there are buttons')
    revealMoreButton.forEach( rvlbtn => {
        rvlbtn.addEventListener( 'click', (e) => {
            //console.log('this is e', e)
            let parent = rvlbtn.parentNode
            //console.log('this is the parent',parent)
            let topicsListItem = parent.querySelectorAll('.list-items-to-hide-or-reveal');
            topicsListItem.forEach( (item, index) => {
                if(index > 3) {
                    item.classList.remove('hide-class');
                }
            });
            parent.querySelector('.reveal-more-btn').classList.add('hide-class');
            parent.querySelector('.hide-more-btn').classList.remove('hide-class');
        })
    })


    hideMoreButton.forEach( hdbtn => {
        hdbtn.addEventListener( 'click', (e) => {
            let parent = hdbtn.parentNode
            //console.log(parent)
            let topicsListItem = parent.querySelectorAll('.list-items-to-hide-or-reveal');
            topicsListItem.forEach( (item, index) => {
                if(index > 3) {
                    item.classList.add('hide-class');
                }
            });
            parent.querySelector('.reveal-more-btn').classList.remove('hide-class');
            parent.querySelector('.hide-more-btn').classList.add('hide-class');
        })
    })

}
